const initialState = {
    proposals: [],
    proposal: null,
    isLoading: false,
    isError: false,
    errorMessage: '',
    proposalUpdated: null,
    proposalCreated: null,
}

export default function proposalReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALL_PROPOSALS':
            return { ...state, proposals: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'GET_PROPOSAL':
            return { ...state, proposal: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'UPDATE_PROPOSAL':
            return { ...state, proposalUpdated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'CREATE_PROPOSAL':
            return { ...state, proposalCreated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'PROPOSAL_ACTION_STARTS':
            return { 
                ...state, 
                isLoading: true,
                proposalCreated: null,
                proposalUpdated: null,
                isError: false,
                errorMessage: ''
            };
        case 'PROPOSAL_ACTION_ERRORS':
            return { ...state, isError: true, errorMessage: action.payload, isLoading: false };
        case 'RESET_PROPOSAL_ERRORS':
            return { 
                ...state, 
                isError: false, 
                errorMessage: '',
            };
        default:
            return state;
    }
}